import React from "react";

import Addons from "../../pages/mods_factory/Addons";
import ShowAddon from "../../pages/mods_factory/Addons/Show";

import Skins from "../../pages/mods_factory/Skins";
import ShowSkin from "../../pages/mods_factory/Skins/Show";

import Worlds from "../../pages/mods_factory/Worlds";
import ShowWorld from "../../pages/mods_factory/Worlds/Show";

import AddonTemplates from '../../pages/mods_factory/AddonTemplates';
import ShowAddonTemplate from "../../pages/mods_factory/AddonTemplates/Show";

import MainSkins from '../../pages/mods_factory/MainSkins';
import ShowMainSkin from "../../pages/mods_factory/MainSkins/Show";

import Users from "../../pages/mods_factory/Users";
import ShowUser from "../../pages/mods_factory/Users/Show";

import Reports from '../../pages/mods_factory/Reports';

const modsfactoryRoutes = [
  { path: '/mods_factory/addons', element: <Addons /> },
  { path: '/mods_factory/addons/trending', element: <Addons /> },
  { path: '/mods_factory/addons/popular', element: <Addons /> },
  { path: '/mods_factory/addons/recents', element: <Addons /> },
  { path: '/mods_factory/addons/:id', element: <ShowAddon /> },

  { path: '/mods_factory/skins', element: <Skins /> },
  { path: '/mods_factory/skins/:id', element: <ShowSkin /> },

  { path: '/mods_factory/worlds', element: <Worlds /> },
  { path: '/mods_factory/worlds/:id', element: <ShowWorld /> },

  { path: '/mods_factory/addon_templates', element: <AddonTemplates /> },
  { path: '/mods_factory/addon_templates/:id', element: <ShowAddonTemplate /> },

  { path: '/mods_factory/main_skins', element: <MainSkins /> },
  { path: '/mods_factory/main_skins/:id', element: <ShowMainSkin /> },

  { path: '/mods_factory/users', element: <Users /> },
  { path: '/mods_factory/users/:id', element: <ShowUser /> },

  { path: '/mods_factory/reports', element: <Reports /> },
  { path: '/mods_factory/reports/addons', element: <Reports /> },
  { path: '/mods_factory/reports/users', element: <Reports /> },
  { path: '/mods_factory/reports/comments', element: <Reports /> },
];

export default modsfactoryRoutes;
